// Maps every English thinking-step string (from backend THINKING_VARIANTS) to Arabic.
const thinkingAr: Record<string, string> = {
  // start
  "Let me look into that for you...": "دعني أبحث عن ذلك...",
  "Just a moment, looking that up...": "لحظة، جاري البحث...",
  "Digging into your question...": "أتعمق في سؤالك...",
  "Let me think about this...": "دعني أفكر في هذا...",
  "Working on it...": "جاري العمل على ذلك...",
  "Let me see what I can find...": "دعني أرى ما يمكنني إيجاده...",
  "On it — give me a sec...": "جاري ذلك — لحظة...",
  "Pulling that together for you...": "أجمع المعلومات لك...",
  "Let me check that out...": "دعني أتحقق من ذلك...",
  "Getting started on your query...": "أبدأ بمعالجة سؤالك...",

  // transfer
  "Finding the best source for your query...": "أبحث عن أفضل مصدر لسؤالك...",
  "Picking the right specialist...": "أختار المتخصص المناسب...",
  "Routing this to the best agent...": "أحيل هذا إلى أفضل وكيل...",
  "Choosing the right tool for the job...": "أختار الأداة المناسبة...",
  "Handing off to a specialist...": "أحيل إلى متخصص...",
  "Figuring out who's best to answer...": "أحدد الأنسب للإجابة...",
  "Matching your question to the right expert...": "أطابق سؤالك مع الخبير المناسب...",
  "Selecting the most relevant agent...": "أختار الوكيل الأكثر صلة...",
  "Deciding the best path forward...": "أحدد أفضل مسار...",
  "Lining up the right resources...": "أجهّز الموارد المناسبة...",

  // fallback
  "Expanding search to find a better answer...": "أوسّع البحث للعثور على إجابة أفضل...",
  "Trying a different angle...": "أجرب زاوية مختلفة...",
  "Looking somewhere else for that...": "أبحث في مكان آخر...",
  "Broadening my search...": "أوسّع نطاق البحث...",
  "Switching approach to dig deeper...": "أغير النهج للتعمق أكثر...",
  "Let me try another source...": "دعني أجرب مصدرًا آخر...",
  "Reaching for a wider net...": "أمد شبكة بحث أوسع...",
  "Checking other places for an answer...": "أتحقق من أماكن أخرى للإجابة...",
  "Refining my search...": "أحسّن بحثي...",
  "Pivoting to a different lead...": "أتجه نحو مسار مختلف...",

  // analyser_agent
  "Crunching the numbers...": "أحلل الأرقام...",
  "Running the analysis...": "أجري التحليل...",
  "Working through the data...": "أعمل على البيانات...",
  "Putting the figures together...": "أجمع الأرقام...",
  "Slicing the data for insights...": "أستخرج رؤى من البيانات...",
  "Comparing the numbers...": "أقارن الأرقام...",
  "Doing the math...": "أجري الحسابات...",
  "Spotting trends in the data...": "أرصد الاتجاهات في البيانات...",
  "Breaking down the metrics...": "أحلل المؤشرات...",
  "Pulling out the key stats...": "أستخرج الإحصاءات الرئيسية...",

  // visualiser_agent
  "Preparing a visual...": "أحضّر رسمًا بيانيًا...",
  "Drafting a chart for you...": "أرسم مخططًا لك...",
  "Plotting the data...": "أرسم البيانات...",
  "Building a visualization...": "أبني تصورًا بصريًا...",
  "Sketching out a chart...": "أخطط رسمًا بيانيًا...",
  "Turning the numbers into a picture...": "أحوّل الأرقام إلى صورة...",
  "Composing a graph...": "أؤلف رسمًا بيانيًا...",
  "Designing a visual summary...": "أصمم ملخصًا مرئيًا...",
  "Putting together a chart...": "أجمع المخطط...",
  "Rendering the data visually...": "أعرض البيانات بصريًا...",

  // environment_agent
  "Searching environmental data...": "أبحث في البيانات البيئية...",
  "Looking through environmental records...": "أتصفح السجلات البيئية...",
  "Scanning environmental sources...": "أفحص المصادر البيئية...",
  "Pulling up environmental info...": "أستدعي المعلومات البيئية...",
  "Checking environmental databases...": "أفحص قواعد البيانات البيئية...",
  "Browsing environmental reports...": "أتصفح التقارير البيئية...",
  "Looking into the environmental side...": "أتناول الجانب البيئي...",
  "Finding the relevant environmental data...": "أبحث عن البيانات البيئية ذات الصلة...",
  "Sifting through environmental sources...": "أغربل المصادر البيئية...",
  "Gathering environmental insights...": "أجمع الرؤى البيئية...",

  // general_info_agent
  "Looking up relevant information...": "أبحث عن المعلومات ذات الصلة...",
  "Gathering background info...": "أجمع معلومات الخلفية...",
  "Pulling up the relevant context...": "أستدعي السياق المناسب...",
  "Searching the knowledge base...": "أبحث في قاعدة المعرفة...",
  "Finding the right details...": "أبحث عن التفاصيل الصحيحة...",
  "Tracking down the information...": "أتتبع المعلومات...",
  "Looking through the references...": "أتصفح المراجع...",
  "Collecting the relevant facts...": "أجمع الحقائق ذات الصلة...",
  "Browsing the source material...": "أتصفح المصادر...",
  "Surfacing the key information...": "أستخرج المعلومات الرئيسية...",

  // retrieval_tool
  "Searching for relevant data...": "أبحث عن البيانات ذات الصلة...",
  "Looking up matching records...": "أبحث عن السجلات المطابقة...",
  "Querying the data store...": "أستعلم من مخزن البيانات...",
  "Fetching the relevant snippets...": "أجلب المقتطفات ذات الصلة...",
  "Retrieving the matching content...": "أسترجع المحتوى المطابق...",
  "Searching the index...": "أبحث في الفهرس...",
  "Pulling matching documents...": "أسحب الوثائق المطابقة...",
  "Scanning for relevant material...": "أفحص المواد ذات الصلة...",
  "Looking through the dataset...": "أتصفح مجموعة البيانات...",
  "Hunting down the relevant pieces...": "أبحث عن الأجزاء ذات الصلة...",

  // search_reports
  "Browsing reports...": "أتصفح التقارير...",
  "Searching through the reports...": "أبحث في التقارير...",
  "Looking across the report library...": "أتصفح مكتبة التقارير...",
  "Scanning the available reports...": "أفحص التقارير المتاحة...",
  "Pulling up matching reports...": "أستدعي التقارير المطابقة...",
  "Sifting through reports...": "أغربل التقارير...",
  "Combing the report archive...": "أفتش أرشيف التقارير...",
  "Finding the right report...": "أبحث عن التقرير المناسب...",
  "Checking the report catalog...": "أفحص فهرس التقارير...",
  "Looking for matching reports...": "أبحث عن تقارير مطابقة...",

  // get_report
  "Reading a report...": "أقرأ تقريرًا...",
  "Opening up the report...": "أفتح التقرير...",
  "Going through the report...": "أتصفح التقرير...",
  "Pulling content from the report...": "أستخرج محتوى التقرير...",
  "Reviewing the report...": "أراجع التقرير...",
  "Skimming the report...": "أطالع التقرير...",
  "Loading the report...": "أحمّل التقرير...",
  "Working through the report...": "أعمل على التقرير...",
  "Pulling the report details...": "أسحب تفاصيل التقرير...",
  "Diving into the report...": "أتعمق في التقرير...",

  // python_repl_tool
  "Running analysis...": "أجري التحليل...",
  "Executing the calculation...": "أنفذ الحساب...",
  "Crunching it in Python...": "أعالجه بالبايثون...",
  "Running the computation...": "أجري العملية الحسابية...",
  "Working out the numbers...": "أحسب الأرقام...",
  "Letting Python do the heavy lifting...": "أترك بايثون يؤدي العمل الثقيل...",
  "Computing the result...": "أحسب النتيجة...",
  "Running the script...": "أشغّل النص البرمجي...",
  "Processing the data...": "أعالج البيانات...",
  "Doing the calculations...": "أجري الحسابات...",

  // generate_chart
  "Building chart...": "أبني المخطط...",
  "Putting the chart together...": "أجمع المخطط...",
  "Drawing it up...": "أرسمه...",
  "Composing the chart...": "أؤلف المخطط...",
  "Generating the visualization...": "أولّد التصور المرئي...",
  "Plotting the chart...": "أرسم المخطط...",
  "Rendering the chart...": "أعرض المخطط...",
  "Assembling the chart...": "أجمع المخطط...",
  "Sketching the chart...": "أخطط المخطط...",
  "Crafting the chart...": "أصنع المخطط...",

  // Fetching data fallback
  "Fetching data...": "أجلب البيانات...",
};

export function translateThinkingStep(step: string): string {
  return thinkingAr[step] ?? step;
}
